export const leasingObjectDependencies: string[] = [
  'leasingObjectType',
  'leasingObject',
  'leasingObjectMake',
  'leasingObjectModel',
  'leasingObjectFuel',
  'leasingObjectEngine',
  'averageTotalMileage',
];
